import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold text-sage-light mb-2">
              ACQUOLINA
            </div>
            <div className="text-sm text-sage-medium font-medium mb-4">
              ROBERTO CATTANEO
            </div>
            <p className="text-neutral-300 mb-4">
              Gastronomia artigianale e servizi di Personal Chef per eventi privati.
              Qualità, passione e tradizione in ogni piatto.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Menu</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/chi-sono" 
                  className="text-neutral-300 hover:text-sage-light transition-colors"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Chi Sono
                </Link>
              </li>
              <li>
                <Link to="/gastronomia" className="text-neutral-300 hover:text-sage-light transition-colors">
                  Gastronomia
                </Link>
              </li>
              <li>
                <Link to="/personal-chef" className="text-neutral-300 hover:text-sage-light transition-colors">
                  Personal Chef
                </Link>
              </li>
              <li>
                <Link 
                  to="/ordina" 
                  className="text-neutral-300 hover:text-sage-light transition-colors"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Ordina
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contatti</h4>
            <ul className="space-y-2 text-neutral-300">
              <li>cattaneoroberto.9@gmail.com</li>
              <li>+39 3458279163</li>
              <li>Via Canale, 82</li>
              <li>Vertova, Italia</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800 mt-8 pt-8 text-center text-neutral-400">
          <p>&copy; 2024 ACQUOLINA - Roberto Cattaneo. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;